import React from 'react';
import './NotFound.css'

const NotFound = () => {
    return (
        <div className="not_found">
        </div>
    );
};

export default NotFound;